var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    background: 'url(' + _vm.showByImg + ')',
  })},[_c('Navigation',{staticStyle:{"position":"fixed","top":"0","width":"100%","z-index":"1000"}}),_vm._v(" "),_c('router-view',{staticStyle:{"padding-top":"80px"}}),_vm._v(" "),(_vm.showFooter)?_c('Footer'):_vm._e(),_vm._v(" "),(_vm.loginForm)?_c('LoginType'):_vm._e(),_vm._v(" "),(_vm.hotGameList)?_c('EmptyAccount'):_vm._e(),_vm._v(" "),(_vm.payConfirm)?_c('PayConfirm'):_vm._e(),_vm._v(" "),(_vm.validAccountForm)?_c('ValidAccount'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2796dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = null
// module chunks = 